import { render } from "./ManagementNavigation.vue?vue&type=template&id=1bc4e104&scoped=true"
import script from "./ManagementNavigation.vue?vue&type=script&lang=ts"
export * from "./ManagementNavigation.vue?vue&type=script&lang=ts"

import "./ManagementNavigation.vue?vue&type=style&index=0&id=1bc4e104&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1bc4e104"

export default script